<script lang="ts">
	import promise_in_flight_store from 'shared/promise_in_flight_store'
	import fetchy from 'shared/fetchy'
	import { storefront_api2_prefix, google_analytics_tag_id } from 'shared/var'
	import ErrorMessage from 'shared/component/ErrorMessage.svelte'
	import TextInput from 'shared/storefront/TextInput.svelte'
	import Button from 'shared/storefront/Button.svelte'
	import Label from 'shared/storefront/Label.svelte'
	import { cookie_to_object } from 'shared/cookie'
	import { onMount } from 'svelte'

	const api2_fetch = fetchy(storefront_api2_prefix)

	let request: Promise<void> | undefined = $state(undefined)
	let name = $state(``)
	let email = $state(``)
	let message = $state(``)
	let open = $state(false)

	onMount(() => {
		const cookie = cookie_to_object(window.document.cookie)
		name = decodeURIComponent(cookie.woocommerce_customer_name || ``)
		email = decodeURIComponent(cookie.woocommerce_customer_email || ``)
	})

	const submit = (event: SubmitEvent) => {
		event.preventDefault()
		request = api2_fetch(`contact`, {
			method: `POST`,
			body: {
				name,
				email,
				message,
				current_url: window.location.href,
			},
		}).then(() => {
			message = ``
		})

		// @ts-expect-error gtag global
		if (typeof gtag !== `undefined`) {
			// @ts-expect-error gtag global
			gtag(`event`, `contact_form_submit`, {
				send_to: google_analytics_tag_id,
			})
		}
	}

	let request_in_flight = $derived(request ? promise_in_flight_store(request) : null)
</script>

<div class="container">
	{#if !open}
		<button class="open" onclick={() => { open = true }} aria-label="Open contact form">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
		</button>
	{:else}
		<div class="header">
			<div class="title">Contact Us</div>
			<button class="close" onclick={() => { open = false; request = undefined }} aria-label="Close contact form">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
			</button>
		</div>

		<form onsubmit={submit}>
			<Label>
				Name
				<TextInput type="text" name="name" autocomplete="name" bind:value={name} required autofocus={!name} disabled={$request_in_flight} />
			</Label>

			<Label>
				Email
				<TextInput type="email" name="email" autocomplete="email" bind:value={email} required autofocus={!name} disabled={$request_in_flight} />
			</Label>

			<Label>
				Message
				<TextInput type="textarea" name="message" bind:value={message} required autofocus={!!name} rows={3} disabled={$request_in_flight} />
			</Label>

			<Button type="submit" disabled={$request_in_flight}>
				Send Email
			</Button>

			{#if request}
				{#await request then }
					<div class="status success">
						Thank you! We'll get back to you soon.
					</div>
				{:catch server_error_response}
					<div class="status error">
						<ErrorMessage {server_error_response} />
					</div>
				{/await}
			{/if}
		</form>
	{/if}
</div>

<style>
	.container {
		position: fixed;
		background: #000;
		font-size: 14px;
		bottom: 0;
		right: 0;
		z-index: 1000;
	}

	.open, .close {
		cursor: pointer;
		background: none;
		border: 0;
		color: #fff;
		padding: 20px;
	}

	.open svg, .close svg {
		display: block;
	}

	.open {
		padding-bottom: 16px;
	}

	form {
		padding: 20px 40px 40px 40px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 100vw;
		max-width: 500px;
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 20px 0 40px;
	}

	.header .title {
		margin: 0;
		color: #fff;
		font-size: 16px;
		font-weight: 500;
		text-transform: uppercase;
		letter-spacing: 3px;
	}

	:global(form textarea) {
		resize: vertical;
		min-height: 60px;
	}

	.success {
		position: absolute;
		top: 70px;
		right: 0;
		bottom: 0;
		left: 0;
		background: black;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.error {
		color: var(--flaregun-red);
	}

</style>

